/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-curly-brace-presence */

'use client'

import React, { Suspense, useEffect, useState } from 'react'
import Image from 'next/image'
import { Lob } from '@enums/Lob'
import { ACKO_LOGO_HORIZONTAL_GRADIENT_DARK, ACKO_LOGO_HORIZONTAL_GRADIENT_WHITE } from '@components/utils/ackoLogoUrls'
import { isChallanLandingWidget, isVasWidget } from '@helpers/vasLandingPageHelper'
import Link from 'next/link'
import { BASE_URL } from '@components/MainWidget/common/commonConstants'
import HomeHeader from '@components/HomeHeader'
import { headerData } from '@constants/commonHeaderData'
import { Locale } from '@enums/strapiTypesAndOperators'
import { getClassNames } from '@helpers/productWidgetHelper'
import { getUrlWithQueryParams } from '@utils/queryParamUtils'
import LanguagePicker from './LanguagePicker'
import styles from './productNav.module.scss'

const lobSemNavBarRequired = {
  [Lob.TRAVEL]: true,
}

const HeaderDesktopAndMweb = ({
  isSemPage = false,
  lob = null,
  data,
  isMobile = true,
  ackoLogo,
  selectedLang = Locale.English,
  availableLocales = [Locale.English],
  tooltipLang,
}: {
  isSemPage?: boolean
  lob?: any
  data?: any
  isMobile?: boolean
  ackoLogo?: string
  selectedLang?: Locale
  availableLocales?: Locale[]
  tooltipLang?: Locale
}) => {
  const isVasLandingWidget = isVasWidget(data?.widget)
  const renderMinimalNavBar =
    (isSemPage && lob && lobSemNavBarRequired[lob]) ||
    (isVasLandingWidget && !!isSemPage && !isChallanLandingWidget(data?.widget))
  const darkTheme = data?.theme !== 'light'
  const [logoUrl, setLogoUrl] = useState(BASE_URL)
  useEffect(() => {
    setLogoUrl(getUrlWithQueryParams(BASE_URL))
  }, [])
  return (
    <Suspense fallback={<div className={styles.loaderStyles} />}>
      {renderMinimalNavBar || isSemPage ? (
        <div
          className={getClassNames([styles.semNavbar], {
            [styles.semNavbarLight]: !darkTheme,
            [styles.semNavbarDark]: darkTheme,
          })}>
          <Link href={logoUrl}>
            <Image
              width={100}
              height={24}
              src={darkTheme ? ACKO_LOGO_HORIZONTAL_GRADIENT_DARK : ACKO_LOGO_HORIZONTAL_GRADIENT_WHITE}
              alt="Acko Company Logo"
              priority
            />
          </Link>
          <LanguagePicker
            selectedLanguage={selectedLang}
            availableLanguages={availableLocales}
            darkIcon={darkTheme}
            tooltipLang={tooltipLang}
          />
        </div>
      ) : (
        <HomeHeader
          isMobile={isMobile}
          data={headerData}
          ackoLogo={ackoLogo}
          isSemPage={isSemPage}
          selectedLanguage={selectedLang}
          availableLanguages={availableLocales}
          tooltipLang={tooltipLang}
        />
      )}
    </Suspense>
  )
}

export default HeaderDesktopAndMweb
